/**
 * Utilidades para miniatura y duración de videos del repositorio.
 */

export function resolveMediaUrl(path) {
  if (!path) return null;
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('blob:') ||
    path.startsWith('data:')
  ) {
    return path;
  }
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${process.env.REACT_APP_LOCATION || ''}${cleanPath}`;
}

export function formatVideoDuration(seconds) {
  if (seconds == null || seconds === '' || Number.isNaN(Number(seconds))) {
    return '—';
  }
  const total = Math.max(0, Math.round(Number(seconds)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Lee la duración (segundos) desde los metadatos del archivo de video.
 * Devuelve null si no se puede obtener (CORS, URL inválida, etc.).
 */
export function probeVideoDuration(url) {
  return new Promise((resolve) => {
    if (!url) {
      resolve(null);
      return;
    }

    const video = document.createElement('video');
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;

    const cleanup = () => {
      video.removeAttribute('src');
      video.load();
    };

    const timer = setTimeout(() => {
      cleanup();
      resolve(null);
    }, 12000);

    video.onloadedmetadata = () => {
      clearTimeout(timer);
      const duration = video.duration;
      cleanup();
      resolve(Number.isFinite(duration) && duration > 0 ? duration : null);
    };

    video.onerror = () => {
      clearTimeout(timer);
      cleanup();
      resolve(null);
    };

    video.src = url;
  });
}

export function mapRepositoryVideo(video) {
  const thumbnailPath =
    video.thumbnailPath ||
    video.ThumbnailPath ||
    video.thumbnail ||
    video.Thumbnail ||
    '';
  const path = video.path || video.Path || '';
  const durationSeconds =
    video.durationSeconds ??
    video.DurationSeconds ??
    video.duration ??
    video.Duration ??
    null;

  return {
    id: video.id ?? video.Id,
    title: video.title || video.Title || '',
    path,
    videoUrl: resolveMediaUrl(path),
    thumbnailPath,
    thumbnail: resolveMediaUrl(thumbnailPath),
    durationSeconds:
      durationSeconds != null && durationSeconds !== '' && Number(durationSeconds) > 0
        ? Number(durationSeconds)
        : null,
    duration: formatVideoDuration(
      durationSeconds != null && Number(durationSeconds) > 0 ? Number(durationSeconds) : null
    ),
  };
}
